import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateTopupConfig, TopupConfigUpdate } from 'api/highnote/topup'
import { highnoteKeys } from './keys'

export const useUpdateTopupConfigMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (update: TopupConfigUpdate) => updateTopupConfig(update),
    onSettled: async () =>
      queryClient.invalidateQueries({
        queryKey: highnoteKeys.topupConfigRoot,
      }),
  })
}
